import './RangeFilter.scss';

import { useState } from "react";

import { Box } from "@mui/material";

import { InputDateTime } from "../../common-components/Inputs/Inputs";

const RangeFilter = ({onRangeChange}) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleStartDateChange = (e) => {
        const value = e.target.value;
        setStartDate(value);
        onRangeChange({ startDate: value, endDate: endDate || '' });
    };

    const handleEndDateChange = (e) => {
        const value = e.target.value;
        setEndDate(value);
        onRangeChange({ startDate: startDate || '', endDate: value });
    };

    return (
        <Box className={"range_filter"}>
            <Box className={"range_filter_container"}>
                <Box className={"range_filter_container_start"}>
                    <InputDateTime value={startDate} onChange={handleStartDateChange}/>
                </Box>
                <Box className={"range_filter_container_finish"}>
                    <InputDateTime value={endDate} onChange={handleEndDateChange}/>
                </Box>
            </Box>
        </Box>
    )
}

export default RangeFilter;